import { data, type ObservableValue } from '@amazon/vinyl-observable'
import { globalData } from '@amzn/amp-playback'

// Shared open/close state for the mobile FullPlayer. The compact
// controls (transport MiniPlayer, chat NanoPlayer) flip this open; the
// FullPlayer's own drag-down / art-tap collapse flips it closed. Kept
// module-scoped (not a router route) so opening the expanded player
// never touches the URL — it's an in-place overlay over whatever the
// user was browsing, and playback/back-stack are untouched.
//
// Lives in `playback/` (a leaf both `transport/` and `blackbolt/`
// already depend on one-way) so the chat surfaces can open the player
// without a `blackbolt → transport` back-edge.
const open$ = globalData(() => data(false))

export const fullPlayerOpen$: ObservableValue<boolean> = open$

export function openFullPlayer(): void {
    open$.value = true
}

export function closeFullPlayer(): void {
    open$.value = false
}
